export function generateUUID() {
  const timestamp = Date.now().toString(36).slice(-4);
  const randomPart = 'xxxx-4xyx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
  return `${timestamp}-${randomPart}`;
}

export function generateUUIDv7() {
  // 현재 시간을 밀리초 단위로 가져옴
  const timestamp = Date.now();

  // UUID v7의 첫 48비트는 timestamp에서 가져옴
  const timeHex = timestamp.toString(16).padStart(12, '0');

  // UUID 버전 7을 의미하는 4비트 추가 (7번째 위치에 "7"을 삽입)
  const version = '7';

  // 랜덤한 12비트 추가
  const randomA = Math.floor(Math.random() * 0xfff)
    .toString(16)
    .padStart(3, '0');

  // Variant 비트 (RFC 4122 규칙: "10xx" 패턴 유지)
  const variant = (8 + Math.floor(Math.random() * 4)).toString(16); // 8, 9, A, B 중 하나

  // 나머지 62비트는 랜덤 값으로 채움
  const randomB = Array.from({ length: 12 }, () =>
    Math.floor(Math.random() * 256)
      .toString(16)
      .padStart(2, '0'),
  ).join('');

  // 최종 UUID 조합 (8-4-4-4-12 형식)
  return `${timeHex.slice(0, 8)}-${timeHex.slice(
    8,
    12,
  )}-${version}${randomA}-${variant}${randomB.slice(0, 3)}-${randomB.slice(
    3,
    15,
  )}`;
}
